import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Avatar } from 'avatar-components/Avatar';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import PortalIdParser from 'PortalIdParser';
import UsageTracker from 'academy-common-lib/utils/UsageTracker';
import { useUserInfo } from '../../../accounts/accountsQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PROFILE_URL_FRAGMENT = '/profile';
const UserAvatarLink = ({
  userEmail,
  userName,
  userId,
  displayAvatar = true,
  position
}) => {
  var _currentUser$user;
  const {
    userInfo: currentUser
  } = useUserInfo();
  const handleProfileClick = () => {
    UsageTracker.trackStandalone('Team', Object.assign({
      action: 'profile-link-click'
    }, position !== undefined && {
      position
    }));
  };
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "400",
    children: [displayAvatar && /*#__PURE__*/_jsx(Box, {
      shrink: 0,
      children: /*#__PURE__*/_jsx(Avatar, {
        lookup: {
          type: 'hubSpotUserEmail',
          primaryIdentifier: userEmail
        },
        portalId: PortalIdParser.get(),
        size: "xs"
      })
    }), /*#__PURE__*/_jsx(UIRouterLink, {
      onClick: handleProfileClick,
      to: userId === (currentUser === null || currentUser === void 0 || (_currentUser$user = currentUser.user) === null || _currentUser$user === void 0 ? void 0 : _currentUser$user.id) ? PROFILE_URL_FRAGMENT : `${PROFILE_URL_FRAGMENT}/${userId}`,
      children: /*#__PURE__*/_jsx(TruncateString, {
        children: userName || userEmail
      })
    })]
  });
};
export default UserAvatarLink;